'use strict';

import 'select2';
import './modules/select2-position';
